import "./index.css";
import { Link } from "react-router-dom";
import PortfolioData from "../../Database/portfolio_projects.json";
import MetaTags from "../../../components/MetaTags";
export default function PortfolioHome() {
    const PortfolioDataArray = PortfolioData.PortfolioExpData
    const moment = require('moment');
    return(
        <>
            <MetaTags   title="Portfolio"
                        description="Here are interesting projects I have worked on the area of Data Science. From raw data to getting sound statistical insights from it to support decision making. Followed CRISP-DM methodology in all the projects."
                        />
        
        <div className="pb-4" id="wd-portfolio">
            <h1 id="wd-portfolio-title">Portfolio</h1> <hr/>
            <p> Here are interesting projects I have worked on the area of Data Science. From raw data to getting sound statistical insights from it to support decision making. Followed CRISP-DM methodology in all the projects. </p>
            <h2 id="wd-portfolio-published"> Projects ({PortfolioDataArray.length}) </h2> <hr/>
            
                <div id="wd-portfolio-projects" className="row ms-4">
                    <div className="row justify-content-center row-cols-1 row-cols-md-5 row-cols-g-4 gy-3">
                    

                    {PortfolioDataArray.map((project)=> (
                        <div className="wd-portfolio-project col" style={{width: "300px"}}>
                            <Link to={`/portfolio/${project._id}/Home`} className="text-decoration-none">
                            <div className="card rounded-3 overflow-hidden h-100">
                                <img className="card-img-top img-fluid" 
                                        src={project._principal_img} width={"160"}  />
                                <div className="card-body d-flex flex-column">
                                    <span className="wd-portfolio-project-link"
                                        style={{textDecoration: "none", color:"navy", fontWeight:"bold"}}>
                                    {project._title}
                                    </span>
                                    <div className="mt-auto"><p className="wd-portfolio-project-title cart-text">
                                    {project._small_description}
                                    </p></div>
                                    <div className="mt-auto"><p className="card-text"><small className="text-muted">End Date: {moment(project._date).format('MM/YYYY')}</small></p></div>
                                    <div className="btn-go mt-auto">
                                        <Link to={`/portfolio/${project._id}/Home`} className="btn btn-primary">Go</Link>
                                    </div>
                                </div>
                            </div>
                            </Link>
                        </div>
                    ))}


                    </div>
                </div>
        </div>
    </>
    );
}